import type { IFilterValue } from 'entities/Contacts/api/filterTypes.ts'
import type { FilterItem } from 'widgets/FilterEditor/model'

const PowerDialerStatusKeys = new Set(['pd_campaign.status'])

export const isPowerDialerStatusWidget = <T extends IFilterValue, C>(
  filterItem: FilterItem<T, C>
) => PowerDialerStatusKeys.has(filterItem.key)
